var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavVideoOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 467",
    style: {
      fill: "none"
    },
    d: "M0 0h26v26H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 771"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 123",
    d: "m258.878 35.192-4.906 2.83a.336.336 0 0 1-.5-.291v-5.66a.336.336 0 0 1 .5-.291l4.906 2.83a.336.336 0 0 1 0 .582",
    transform: "translate(-242.522 -21.966)",
    style: {
      fill: "#7833ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 124",
    d: "M245.065 4.377h-4.906a.648.648 0 0 0-.648.648v.9a.283.283 0 0 1-.283.283h-12.77a.448.448 0 0 1-.448-.448v-.735a.648.648 0 0 0-.648-.648h-4.907a.648.648 0 0 0-.647.648v22.621a.648.648 0 0 0 .647.648h4.907a.647.647 0 0 0 .648-.647v-.911a.283.283 0 0 1 .283-.283h12.935a.283.283 0 0 1 .283.283v.911a.647.647 0 0 0 .648.648h4.906a.647.647 0 0 0 .648-.648V5.025a.648.648 0 0 0-.648-.648M224.259 24a.467.467 0 0 1-.467.467h-1.756a.467.467 0 0 1-.467-.467v-1.753a.467.467 0 0 1 .467-.467h1.756a.467.467 0 0 1 .467.467zm0-6.765a.467.467 0 0 1-.467.467h-1.756a.467.467 0 0 1-.467-.467v-1.753a.467.467 0 0 1 .467-.467h1.756a.467.467 0 0 1 .467.467zm0-6.765a.467.467 0 0 1-.467.467h-1.756a.467.467 0 0 1-.467-.467V8.716a.467.467 0 0 1 .467-.467h1.756a.467.467 0 0 1 .467.467zm8.506 11.639a5.777 5.777 0 1 1 5.743-6.407 5.777 5.777 0 0 1-5.743 6.407M243.962 24a.467.467 0 0 1-.467.467h-1.756a.467.467 0 0 1-.467-.467v-1.753a.467.467 0 0 1 .467-.467h1.756a.467.467 0 0 1 .467.467zm0-6.785a.467.467 0 0 1-.467.467h-1.756a.467.467 0 0 1-.467-.467v-1.753a.467.467 0 0 1 .467-.467h1.756a.467.467 0 0 1 .467.467zm0-6.756a.467.467 0 0 1-.467.467h-1.756a.467.467 0 0 1-.467-.467V8.706a.467.467 0 0 1 .467-.467h1.756a.467.467 0 0 1 .467.467z",
    transform: "translate(-219.76 -3.466)",
    style: {
      fill: "#7833ba"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavVideoOn);
export default __webpack_public_path__ + "static/media/nav_video_on.ce3471130e34c3dea33a84b782201e72.svg";
export { ForwardRef as ReactComponent };